import { render, staticRenderFns } from "./TermoDesentranhamentoJuntar.vue?vue&type=template&id=2516944a&scoped=true"
import script from "./TermoDesentranhamentoJuntar.vue?vue&type=script&lang=js"
export * from "./TermoDesentranhamentoJuntar.vue?vue&type=script&lang=js"
import style0 from "./TermoDesentranhamentoJuntar.vue?vue&type=style&index=0&id=2516944a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2516944a",
  null
  
)

export default component.exports